import Header from "../../components/Header/Header";
import MainOptions from "../../components/MainOptions/MainOptions";
import Footer from "../../components/Footer/Footer";

export default function Home() {
  return (
    <>
      <Header />
      <MainOptions />
      <Footer />
    </>
  );
}